import useUIUtilsContext from './useUIUtilsContext';
export default function useLogger() {
  const context = useUIUtilsContext();
  return (context == null ? void 0 : context.logger) || console;
}